import { render } from "./SubscribeForm.vue?vue&type=template&id=56b56a33&scoped=true"
import script from "./SubscribeForm.vue?vue&type=script&lang=js"
export * from "./SubscribeForm.vue?vue&type=script&lang=js"

import "./SubscribeForm.vue?vue&type=style&index=0&id=56b56a33&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b56a33"]])

export default __exports__